import { whenAll } from 'platform/shared/health-apps';
import content from '../locales/en/content.json';
import {
  isExistingSubmission,
  isNewSubmission,
  sponsorIsLiving,
} from '../utils/helpers';
import { applicantPages } from './applicant';
import { applicationStatusPages } from './applicationStatus';
import { certifierPages } from './certifier';
import { eligibilityPages } from './eligibility';
import { healthInsurancePages } from './healthInsurance';
import { medicarePages } from './medicare';
import { sponsorPages } from './sponsor';
import { supplementalPages } from './supplementalInfo';

export const chapters = {
  applicationStatus: {
    title: content['app-status--chapter-title'],
    pages: applicationStatusPages,
  },
  eligibilityInformation: {
    title: content['eligibility--chapter-title'],
    pages: eligibilityPages,
    depends: isNewSubmission,
  },
  supplementalInformation: {
    title: content['supplemental--chapter-title'],
    pages: supplementalPages,
    depends: isExistingSubmission,
  },
  sponsorInformation: {
    title: content['sponsor--chapter-title'],
    pages: sponsorPages,
    depends: whenAll(isNewSubmission, sponsorIsLiving),
  },
  applicantInformation: {
    title: content['applicants--chapter-title'],
    pages: applicantPages,
    depends: isNewSubmission,
  },
  medicareInformation: {
    title: content['medicare--chapter-title'],
    pages: medicarePages,
    depends: isNewSubmission,
  },
  healthInsuranceInformation: {
    title: content['health-insurance--chapter-title'],
    pages: healthInsurancePages,
    depends: isNewSubmission,
  },
  certifierInformation: {
    title: content['certifier--chapter-title'],
    pages: certifierPages,
    depends: isNewSubmission,
  },
};
